(() => {
  'use strict';

  const $ = (selector, root = document) =>
    root.querySelector(selector);

  const $$ = (selector, root = document) =>
    [...root.querySelectorAll(selector)];

  const shopRoot =
    window.Shopify?.routes?.root || '/';

  let toastTimer = null;
  let audioContext = null;
  let memoryGameInitialised = false;
  let quickAddInitialised = false;
  let cartSyncInitialised = false;


  /* =========================================
     AUDIO
  ========================================== */

  function getAudioContext() {
    try {
      const AudioContextClass =
        window.AudioContext ||
        window.webkitAudioContext;

      if (!AudioContextClass) return null;

      if (!audioContext) {
        audioContext = new AudioContextClass();
      }

      if (audioContext.state === 'suspended') {
        audioContext.resume().catch(() => {});
      }

      return audioContext;
    } catch (_) {
      return null;
    }
  }

  function playTone(
    frequency,
    duration,
    volume = 0.12,
    delay = 0
  ) {
    const context = getAudioContext();

    if (!context) return;

    const oscillator =
      context.createOscillator();

    const gain =
      context.createGain();

    const now =
      context.currentTime + delay;

    oscillator.type = 'sine';

    oscillator.frequency.setValueAtTime(
      frequency,
      now
    );

    gain.gain.setValueAtTime(
      0.0001,
      now
    );

    gain.gain.exponentialRampToValueAtTime(
      volume,
      now + 0.02
    );

    gain.gain.exponentialRampToValueAtTime(
      0.0001,
      now + duration
    );

    oscillator.connect(gain);
    gain.connect(context.destination);

    oscillator.start(now);

    oscillator.stop(
      now + duration + 0.01
    );
  }

  function playBasketDing() {
    playTone(880, 0.20, 0.14, 0);
    playTone(1320, 0.18, 0.10, 0.07);
  }

  function playMemoryCheer() {
    const notes = [
      [523.25, 0.00, 0.20],
      [659.25, 0.10, 0.20],
      [783.99, 0.20, 0.22],
      [1046.50, 0.32, 0.38]
    ];

    notes.forEach(
      ([frequency, delay, duration], index) => {
        playTone(
          frequency,
          duration,
          index === notes.length - 1
            ? 0.16
            : 0.11,
          delay
        );
      }
    );
  }


  /* =========================================
     CART TOAST
  ========================================== */

  function showCartToast(message) {
    const toast =
      $('[data-cart-toast]');

    if (!toast) return;

    toast.textContent = message;

    toast.classList.add(
      'is-visible'
    );

    clearTimeout(toastTimer);

    toastTimer =
      window.setTimeout(() => {
        toast.classList.remove(
          'is-visible'
        );
      }, 1800);
  }


  /* =========================================
     BASKET ANIMATION
  ========================================== */

  function bumpBasket() {
    $(
      '.yvrn-header__cart, .yvrn-basket-link'
    ).forEach(link => {
      link.classList.remove(
        'yvrn-basket-bump'
      );

      void link.offsetWidth;

      link.classList.add(
        'yvrn-basket-bump'
      );

      window.setTimeout(() => {
        link.classList.remove(
          'yvrn-basket-bump'
        );
      }, 450);
    });
  }


  /* =========================================
     CART COUNT
  ========================================== */

  async function updateCartCount() {
    try {
      const response =
        await fetch(
          `${shopRoot}cart.js`,
          {
            method: 'GET',
            headers: {
              Accept:
                'application/json'
            },
            cache: 'no-store'
          }
        );

      if (!response.ok) return;

      const cart =
        await response.json();

      const itemCount =
        Number(
          cart.item_count || 0
        );

      $$(
        '.yvrn-header__cart-count, .yvrn-cart-count'
      ).forEach(element => {
        element.textContent =
          `(${itemCount})`;
      });

    } catch (error) {
      console.error(
        'YVRN cart count error:',
        error
      );
    }
  }


  /* =========================================
     QUICK ADD
  ========================================== */

  async function quickAdd(button) {
    if (
      !button ||
      button.dataset.loading === 'true' ||
      button.disabled
    ) {
      return;
    }

    const variantId =
      button.dataset.variantId;

    if (!variantId) {
      showCartToast(
        'ITEM UNAVAILABLE'
      );
      return;
    }

    button.dataset.loading = 'true';
    button.disabled = true;

    getAudioContext();

    try {
      const response =
        await fetch(
          `${shopRoot}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              Accept:
                'application/json'
            },
            body:
              JSON.stringify({
                items: [
                  {
                    id:
                      Number(variantId),
                    quantity: 1
                  }
                ]
              })
          }
        );

      if (!response.ok) {
        const errorText =
          await response.text();

        console.error(
          'YVRN Shopify add error:',
          errorText
        );

        throw new Error(
          'Cart add failed'
        );
      }

      await response.json();

      await updateCartCount();

      playBasketDing();
      bumpBasket();

      showCartToast(
        'ITEM ADDED TO BASKET'
      );

      document.dispatchEvent(
        new CustomEvent(
          'yvrn:cart-updated'
        )
      );

    } catch (error) {
      console.error(
        'YVRN Quick Add error:',
        error
      );

      showCartToast(
        'COULD NOT ADD ITEM'
      );

    } finally {
      button.dataset.loading =
        'false';

      button.disabled = false;
    }
  }

  function initQuickAdd() {
    if (quickAddInitialised) return;

    const buttons =
      $$('[data-quick-add]');

    if (!buttons.length) return;

    quickAddInitialised = true;

    buttons.forEach(button => {
      if (
        button.dataset.yvrnQuickAddBound ===
        'true'
      ) {
        return;
      }

      button.dataset.yvrnQuickAddBound =
        'true';

      button.addEventListener(
        'click',
        event => {
          event.preventDefault();
          event.stopPropagation();

          quickAdd(button);
        }
      );
    });
  }


  /* =========================================
     CART SYNC
  ========================================== */

  function initCartSync() {
    if (cartSyncInitialised) return;

    cartSyncInitialised = true;

    updateCartCount();

    window.setInterval(
      updateCartCount,
      3000
    );

    document.addEventListener(
      'visibilitychange',
      () => {
        if (!document.hidden) {
          updateCartCount();
        }
      }
    );

    window.addEventListener(
      'pageshow',
      updateCartCount
    );
  }


  /* =========================================
     SHOWCASE
  ========================================== */

  function initShowcase() {
    document.addEventListener(
      'click',
      event => {
        const card =
          event.target.closest(
            '[data-showcase-card]'
          );

        if (!card) return;

        if (
          event.target.closest(
            '[data-quick-add]'
          )
        ) {
          return;
        }

        if (
          !card.classList.contains(
            'is-armed'
          )
        ) {
          event.preventDefault();

          $$(
            '[data-showcase-card]'
          ).forEach(other => {
            if (other !== card) {
              other.classList.remove(
                'is-armed'
              );
            }
          });

          card.classList.add(
            'is-armed'
          );
        }
      }
    );
  }


  /* =========================================
     HEADER MENU
  ========================================== */

  function initHeaderMenu() {
    const toggle =
      $('[data-yvrn-menu-toggle]') ||
      $('[data-menu-toggle]');

    const menu =
      $('[data-yvrn-menu]') ||
      $('[data-menu]');

    const header =
      $('[data-yvrn-header]') ||
      $('.yvrn-header');

    if (!toggle || !menu || !header) {
      return;
    }

    if (
      toggle.dataset.yvrnBound ===
      'true'
    ) {
      return;
    }

    toggle.dataset.yvrnBound =
      'true';

    const closeMenu = () => {
      menu.classList.remove(
        'is-open'
      );

      toggle.classList.remove(
        'is-open'
      );

      toggle.setAttribute(
        'aria-expanded',
        'false'
      );

      toggle.setAttribute(
        'aria-label',
        'Open menu'
      );
    };

    const openMenu = () => {
      menu.classList.add(
        'is-open'
      );

      toggle.classList.add(
        'is-open'
      );

      toggle.setAttribute(
        'aria-expanded',
        'true'
      );

      toggle.setAttribute(
        'aria-label',
        'Close menu'
      );
    };

    toggle.addEventListener(
      'click',
      event => {
        event.preventDefault();
        event.stopPropagation();

        if (
          menu.classList.contains(
            'is-open'
          )
        ) {
          closeMenu();
        } else {
          openMenu();
        }
      }
    );

    document.addEventListener(
      'click',
      event => {
        if (
          !header.contains(
            event.target
          )
        ) {
          closeMenu();
        }
      }
    );

    document.addEventListener(
      'keydown',
      event => {
        if (event.key === 'Escape') {
          closeMenu();
        }
      }
    );

    menu
      .querySelectorAll('a')
      .forEach(link => {
        link.addEventListener(
          'click',
          () => {
            if (
              link.classList.contains(
                'yvrn-header__contact'
              )
            ) {
              return;
            }

            closeMenu();
          }
        );
      });
  }


  /* =========================================
     HEADER LOGO SPIN
  ========================================== */

  function initHeaderLogoSpin() {
    const logo =
      $('.yvrn-header__logo img');

    if (!logo) return;

    if (
      logo.dataset.yvrnSpinInitialised ===
      'true'
    ) {
      return;
    }

    logo.dataset.yvrnSpinInitialised =
      'true';

    let rotation = 0;
    let lastTime = performance.now();

    const rotationSpeed =
      360 / 8000;

    function spinLogo(currentTime) {
      const delta =
        currentTime - lastTime;

      lastTime =
        currentTime;

      rotation +=
        delta * rotationSpeed;

      if (rotation >= 360) {
        rotation -= 360;
      }

      logo.style.transform =
        `rotateY(${rotation}deg)`;

      requestAnimationFrame(
        spinLogo
      );
    }

    requestAnimationFrame(
      spinLogo
    );
  }


  /* =========================================
     MEMORY DROP
     3 PAIRS / 10 SECOND TIMER
  ========================================== */

  function initMemoryGame() {

    if (memoryGameInitialised) {
      return;
    }

    const game =
      $('[data-yvrn-memory-game]');

    if (!game) return;

    const grid =
      $('[data-yvrn-memory-grid]', game);

    const timerText =
      $('[data-yvrn-timer]', game);

    const timerFill =
      $('[data-yvrn-timer-fill]', game);

    const state =
      $('[data-yvrn-memory-state]', game);

    const timerArea =
      $('[data-yvrn-timer-area]', game);

    const wonResult =
      $('[data-yvrn-result="won"]', game);

    const lostResult =
      $('[data-yvrn-result="lost"]', game);

    const restartButtons =
      $$('[data-yvrn-restart]', game);

    const copyButton =
      $('[data-yvrn-copy-code]', game);

    const logo =
      game.dataset.yvrnLogo ||
      $('.yvrn-home')?.dataset.yvrnLogo;

    if (
      !grid ||
      !timerText ||
      !timerFill ||
      !state ||
      !logo
    ) {
      console.error(
        'YVRN Memory Drop: required element missing.'
      );
      return;
    }

    memoryGameInitialised = true;

    const TIMER_SECONDS = 10;

    const PAIR_COLOURS = [
      'red',
      'white',
      'black'
    ];

    let cards = [];
    let selected = [];
    let timer = null;
    let remaining = TIMER_SECONDS;
    let gameState = 'idle';
    let resolvingPair = false;


    /* =========================================
       SHUFFLE
    ========================================== */

    function shuffle(array) {
      const result =
        array.slice();

      for (
        let i = result.length - 1;
        i > 0;
        i--
      ) {
        const j =
          Math.floor(
            Math.random() * (i + 1)
          );

        [
          result[i],
          result[j]
        ] = [
          result[j],
          result[i]
        ];
      }

      return result;
    }


    /* =========================================
       BUILD DECK
    ========================================== */

    function buildDeck() {
      const deck = [];

      PAIR_COLOURS.forEach(
        (colour, pairId) => {

          deck.push({
            id: pairId * 2,
            pairId,
            colour,
            flipped: false,
            matched: false
          });

          deck.push({
            id: pairId * 2 + 1,
            pairId,
            colour,
            flipped: false,
            matched: false
          });

        }
      );

      return shuffle(deck);
    }


    /* =========================================
       TIMER
    ========================================== */

    function stopTimer() {
      if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function updateTimer() {
      const safe =
        Math.max(
          0,
          remaining
        );

      timerText.textContent =
        String(safe);

      const percentage =
        Math.max(
          0,
          Math.min(
            100,
            (safe / TIMER_SECONDS) * 100
          )
        );

      timerFill.style.width =
        `${percentage}%`;

      if (safe <= 3) {
        timerText.style.color =
          '#8a0000';

        timerFill.style.background =
          '#8a0000';
      } else {
        timerText.style.color = '';
        timerFill.style.background =
          '#f5f5f5';
      }
    }

    function startTimer() {
      stopTimer();

      remaining =
        TIMER_SECONDS;

      updateTimer();

      timer =
        window.setInterval(
          () => {

            remaining -= 1;

            updateTimer();

            if (
              remaining <= 0
            ) {
              stopTimer();
              loseGame();
            }

          },
          1000
        );
    }


    /* =========================================
       RESULT DISPLAY
    ========================================== */

    function showResult(which) {

      if (wonResult) {
        wonResult.classList.toggle(
          'is-visible',
          which === 'won'
        );
      }

      if (lostResult) {
        lostResult.classList.toggle(
          'is-visible',
          which === 'lost'
        );
      }

      if (state) {
        state.style.display =
          which === 'idle'
            ? 'block'
            : 'none';
      }

      if (grid) {
        grid.style.display =
          'grid';
      }

      if (timerArea) {
        timerArea.style.display =
          '';
      }
    }


    /* =========================================
       CARD RENDER
    ========================================== */

    function render() {

      grid.innerHTML = '';

      cards.forEach(card => {

        const button =
          document.createElement(
            'button'
          );

        button.type = 'button';

        button.className =
          'yvrn-memory-card';

        button.dataset.id =
          String(card.id);

        button.setAttribute(
          'aria-label',
          'Memory card'
        );

        button.innerHTML = `
          <span class="yvrn-memory-card__inner">

            <span
              class="yvrn-face yvrn-face--back"
              aria-hidden="true"
            >
              <img
                src="${logo}"
                alt=""
              >
            </span>

            <span
              class="yvrn-face yvrn-face--front yvrn-face--${card.colour}"
            >
              <img
                src="${logo}"
                alt="YVRN"
              >
            </span>

          </span>
        `;

        button.addEventListener(
          'click',
          () => {
            flipCard(card.id);
          }
        );

        grid.appendChild(
          button
        );
      });
    }


    /* =========================================
       CARD ELEMENT
    ========================================== */

    function getCardElement(id) {
      return grid.querySelector(
        `[data-id="${id}"]`
      );
    }


    /* =========================================
       WIN
    ========================================== */

    function winGame() {

      stopTimer();

      gameState = 'won';

      selected = [];

      resolvingPair = false;

      showResult('won');

      playMemoryCheer();
    }


    /* =========================================
       LOSS
    ========================================== */

    function loseGame() {

      stopTimer();

      gameState = 'lost';

      selected = [];

      resolvingPair = false;

      showResult('lost');
    }


    /* =========================================
       FLIP CARD
    ========================================== */

    function flipCard(id) {

      if (
        gameState === 'won' ||
        gameState === 'lost'
      ) {
        return;
      }

      if (
        resolvingPair ||
        selected.length >= 2
      ) {
        return;
      }

      const card =
        cards.find(
          item =>
            item.id === id
        );

      if (
        !card ||
        card.flipped ||
        card.matched
      ) {
        return;
      }

      if (
        gameState === 'idle'
      ) {
        getAudioContext();

        gameState =
          'playing';

        startTimer();
      }

      card.flipped = true;

      const element =
        getCardElement(id);

      if (element) {
        element.classList.add(
          'is-flipped'
        );
      }

      selected.push(id);

      if (
        selected.length !== 2
      ) {
        return;
      }

      resolvingPair = true;

      const first =
        cards.find(
          item =>
            item.id === selected[0]
        );

      const second =
        cards.find(
          item =>
            item.id === selected[1]
        );

      if (!first || !second) {
        selected = [];
        resolvingPair = false;
        return;
      }


      /* =========================================
         MATCH
      ========================================== */

      if (
        first.pairId ===
        second.pairId
      ) {

        window.setTimeout(
          () => {

            if (
              gameState !==
              'playing'
            ) {
              resolvingPair = false;
              return;
            }

            first.matched = true;
            second.matched = true;

            const firstElement =
              getCardElement(
                first.id
              );

            const secondElement =
              getCardElement(
                second.id
              );

            if (firstElement) {
              firstElement.classList.add(
                'is-matched'
              );
            }

            if (secondElement) {
              secondElement.classList.add(
                'is-matched'
              );
            }

            selected = [];
            resolvingPair = false;

            if (
              cards.every(
                item =>
                  item.matched
              )
            ) {
              winGame();
            }

          },
          400
        );

        return;
      }


      /* =========================================
         WRONG PAIR
      ========================================== */

      window.setTimeout(
        () => {

          if (
            gameState !==
            'playing'
          ) {
            resolvingPair = false;
            return;
          }

          first.flipped = false;
          second.flipped = false;

          const firstElement =
            getCardElement(
              first.id
            );

          const secondElement =
            getCardElement(
              second.id
            );

          if (firstElement) {
            firstElement.classList.remove(
              'is-flipped'
            );
          }

          if (secondElement) {
            secondElement.classList.remove(
              'is-flipped'
            );
          }

          selected = [];
          resolvingPair = false;

        },
        900
      );
    }


    /* =========================================
       RESTART
    ========================================== */

    function restart() {

      stopTimer();

      cards =
        buildDeck();

      selected = [];

      remaining =
        TIMER_SECONDS;

      gameState =
        'idle';

      resolvingPair = false;

      if (copyButton) {
        copyButton.textContent =
          'YVRN10';

        copyButton.disabled =
          false;

        copyButton.dataset.copying =
          'false';
      }

      render();

      updateTimer();

      showResult('idle');
    }


    restartButtons.forEach(
      button => {

        button.addEventListener(
          'click',
          event => {

            event.preventDefault();
            event.stopPropagation();

            restart();
          }
        );

      }
    );


    /* =========================================
       COPY CODE
    ========================================== */

    function showCopiedState(button) {

      button.textContent =
        'COPIED!';

      button.disabled = true;

      window.setTimeout(
        () => {

          button.textContent =
            'YVRN10';

          button.disabled =
            false;

          button.dataset.copying =
            'false';

        },
        2000
      );
    }


    if (copyButton) {

      copyButton.addEventListener(
        'click',
        event => {

          event.preventDefault();
          event.stopPropagation();

          if (
            copyButton.dataset.copying ===
            'true'
          ) {
            return;
          }

          copyButton.dataset.copying =
            'true';

          const code =
            'YVRN10';

          let copied = false;

          try {

            const textarea =
              document.createElement(
                'textarea'
              );

            textarea.value =
              code;

            textarea.setAttribute(
              'readonly',
              ''
            );

            textarea.style.position =
              'fixed';

            textarea.style.top = '0';
            textarea.style.left =
              '-10000px';

            textarea.style.width =
              '1px';

            textarea.style.height =
              '1px';

            textarea.style.opacity =
              '0';

            textarea.style.pointerEvents =
              'none';

            document.body.appendChild(
              textarea
            );

            textarea.focus();
            textarea.select();

            textarea.setSelectionRange(
              0,
              textarea.value.length
            );

            copied =
              document.execCommand(
                'copy'
              );

            textarea.remove();

          } catch (_) {
            copied = false;
          }

          if (!copied) {

            if (
              navigator.clipboard &&
              typeof navigator.clipboard.writeText ===
              'function'
            ) {

              navigator.clipboard
                .writeText(code)
                .then(
                  () => {
                    showCopiedState(
                      copyButton
                    );
                  }
                )
                .catch(
                  () => {
                    copyButton.dataset.copying =
                      'false';
                  }
                );

              return;
            }

            copyButton.dataset.copying =
              'false';

            return;
          }

          showCopiedState(
            copyButton
          );
        }
      );
    }


    /* =========================================
       INITIAL GAME
    ========================================== */

    cards =
      buildDeck();

    selected = [];

    remaining =
      TIMER_SECONDS;

    gameState =
      'idle';

    resolvingPair = false;

    render();

    updateTimer();

    showResult('idle');
  }


  /* =========================================
     BOOT
  ========================================== */

  function boot() {

    initQuickAdd();

    initCartSync();

    initShowcase();

    initHeaderMenu();

    initHeaderLogoSpin();

    initMemoryGame();
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );

  } else {

    boot();

  }


  /* =========================================
     SHOPIFY SECTION LOAD
  ========================================== */

  document.addEventListener(
    'shopify:section:load',
    () => {

      quickAddInitialised =
        false;

      initQuickAdd();
      initHeaderMenu();
      initHeaderLogoSpin();
      initMemoryGame();
      updateCartCount();

    }
  );


  document.addEventListener(
    'cart:updated',
    updateCartCount
  );

  document.addEventListener(
    'yvrn:cart-updated',
    updateCartCount
  );

})();